import NoSleep from "nosleep.js";

export const noSleep = new NoSleep();
